/**
 * frontend.js
 *
 * @author jjarolim, office@jarolim.com
 */

// nothing yet